import * as React from "react";

import { Context } from "../Context";

export function Projects() {
  const context: any = React.useContext(Context);
  const projects = context.data.projects;
  if (!projects.items) {
    return null;
  }
  return (
    <div id="projects">
      <h2>Projects</h2>
      {Object.keys(projects.items).map(projectsHeader => {
        return (
          <div key={projectsHeader} className="grid-x">
            <div className="cell">
              <h3>{projectsHeader}</h3>
            </div>
          </div>
        );
      })}
    </div>
  );
}
